<template>
    <div class="flex-grow-1-scroll h-100 no-gutters bg-white provider-content" ref="container">
        <loading ref="loading"></loading>
        <edit-appointment
            v-on:appointmentUpdated='getAppointmentSessions(user_id, site_id)'
            v-on:appointmentDeleted='getAppointmentSessions(user_id, site_id)'
            ref='editAppointment'
            v-bind:appointment.sync='selected_appointment'
            v-bind:session.sync='selected_session'/>
		<div class="d-flex flex-column h-100">

            <header class="p-2 header__dashboard--top d-flex align-items-center" style="z-index: 100;">
                <h1 class="h2" style="">Appointments</h1>
            </header>

            <div class="m-2">
                <form>
                    <div class="form-group d-flex align-items-center">
                        <label class="col-form-label">Select clinician</label>
                        <select class="form-control col-6 ml-2" v-model='user_id'>
                            <option v-for="user in sortByValue(users, 'surname')" :key='user.id' :value='user.id' v-text='formatNameCompliant(user)'></option>
                        </select>
                        <div class='ml-2'>
                        <router-link v-if='user_id && (is_admin() || is_superuser())' class="btn btn-round btn-sm btn-primary" :to='"/staff-list/staff-edit/" + user_id + "#appointments"'>Edit session data</router-link>
                        </div>

                        <label class="col-form-label ml-2">Select site</label>
                        <select class="form-control col-6 ml-2" v-model='site_id'>
                            <option value='-1'>All sites</option>
                            <option v-for="site in $root.provider.site" :key='site.id' :value='site.id' v-text='site.name'></option>
                        </select>
                        <div class='ml-2'>
                        <router-link v-if='user_id && (is_admin() || is_superuser())' class="btn btn-round btn-sm btn-primary" :to='"/staff-list/staff-edit/" + user_id + "#rota"'>Edit availability</router-link>
                        </div>
                    </div>
                </form>
            </div>

            <div class="m-2 flex-grow-1-scroll h-100">
                <div v-if='!user_id'>
                    Please select a clinician to view their calendar.
                </div>

                <div v-else-if='sessions.length == 0'>
                    The selected clinician doesn't have any appointment sessions<template v-if='site_id && site_id != -1'> at the selected site</template>.
                </div>

                <div v-else class='d-flex flex-row calendar--wrap'>
                    <div v-bind:style='{
                                flexShrink: 0,
                                position: "relative",
                                width: "" + dayWidth + "px",
                                //backgroundColor: "#d0d0d0",
                                backgroundColor: "#f2f2f2",
                                marginRight: "1em"
                            }' class="calendar--pending">
                        <div v-bind:style='{height: "" + dayHeadingHeight + "em"}' ><h3>Pending Invitations</h3></div>
                        <div v-for='appointment in pending_invitations' :key='appointment.id'
                        v-bind:style='{
                                        //width: "" + (dayWidth - (dayBorderWidth * 2)) + "px",
                                        width: "230px",
                                        overflow: "hidden",
                                        //top: getOffset(appointment),
                                        height: getHeight(appointment),
                                        paddingLeft: ".2em",
                                        border: "1px solid grey",
                                        backgroundColor: (appointment.available ? "white" : "lightblue"),
                                        opacity: (appointment.available ? 0.5 : 1),

                                        borderRadius: "5px",
                                    }'
                                    v-on:click='appointment.appointment ? editAppointment(appointment) : createAppointment(appointment)'

                                    >

                            {{appointment.app_app_session_type_xref.map((elem) => {
                                return elem.appointment_session_type.name;
                            }).join(",")}}<br />
                            {{formatNameCompliant(appointment.user)}}
                        </div>

                    </div>

                    <div style='position: relative;' class="calendar--time">
                        <div v-bind:style='{height: "" + dayHeadingHeight + "em"}' ><!-- blank for date heading alignment --></div>
                        <div v-bind:style='{height: "" + m15Height + "em"}' v-for='time in time_intervals' :key='time.format("HH:mm")'>{{time.format("HH:mm")}}</div>
                    </div>

                    <template v-for='day in days'>
                    <div v-if='sessions[day.format("YYYY-MM-DD")] && sessions[day.format("YYYY-MM-DD")].length'
                            v-bind:style='{
                                flexShrink: 0,
                                position: "relative",
                                width: "" + dayWidth + "px",
                                //backgroundColor: "#d0d0d0",
                                marginLeft: ".2em"
                            }' :key='day.format("YYYY-MM-DD")'

                             class="calendar--date">
                        <div v-bind:style='{height: "" + dayHeadingHeight + "em"}' class="calendar--day">{{day.format("ddd")}} <span>{{day.format(" Do")}}</span></div>
                        <template v-for='appointment in sessions[day.format("YYYY-MM-DD")]'>
                            <div v-if='!appointment.overlaps_booked && !appointment.overlaps' class="calendar--date__item" v-bind:style='{
                                        position: "absolute",
                                        width: "" + (dayWidth - (dayBorderWidth * 2)) + "px",
                                        overflow: "hidden",
                                        top: getOffset(appointment),
                                        height: getHeight(appointment),
                                        paddingLeft: ".2em",
                                        border: "1px solid grey",
                                        backgroundColor: (appointment.available ? "white" : "lightblue"),
                                        opacity: (appointment.available ? 0.5 : 1),

                                        borderRadius: "5px",
                                    }'
                                    :key='appointment.start_at'
                                    v-on:click='appointment.appointment ? editAppointment(appointment) : createAppointment(appointment)'

                                    >
                                    {{appointment.appointment_session_type.name}} - {{moment(appointment.start_at).format("HH:mm")}} - {{moment(appointment.end_at).add(1, "minutes").format("HH:mm")}}

                                    <template v-if='appointment.appointment'>
                                        <br />{{formatNameCompliant(appointment.appointment.user)}}
                                    </template>
                                </div>
                        </template>
                    </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'id'
    ],
    data: function() {
        return {
            users: this.$root.lookup.staff,
            user_id: null,
            site_id: -1,
            sessions: [],
            time_intervals: [],
            days: [],
            m15Height: 5,
            dayHeadingHeight: 5,
            dayWidth: 250,
            dayBorderWidth: 0,
            selected_appointment: null,
            selected_session: null,
            channel: null,
            pending_invitations: []
        }
    },
    watch: {
        "user_id": function() {
            this.changeChannel("appointmentavailability." + this.user_id);
            this.getAppointmentSessions(this.user_id, this.site_id);
        },
        "site_id": function() {
            this.getAppointmentSessions(this.user_id, this.site_id);
        }
    },
    mounted: function() {
        if(!this.user_id) {
            this.user_id = this.$root.user.id;
        }
        if(this.user_id) {
            this.getAppointmentSessions(this.user_id, this.site_id);
        }

        this.setTimeDateIntervals();
    },
    beforeDestroy() {
        this.deinitData();
    },
    beforeRouteLeave (to, from, next) {
        this.deinitData();
        next();
    },
    methods: {
        deinitData() {
            window.Echo.leave(this.channel);
        },
        changeChannel(new_channel) {
            if(this.channel) {
                console.log("1. Leaving: " + this.channel);
                window.Echo.leave(this.channel);
            }
            this.channel = new_channel;
            console.log("1. Joining: " + this.channel);
            window.Echo.private(this.channel)
                .listen('UpdateAppointmentAvailability', (e) => {
                    this.getAppointmentSessions(this.user_id, this.site_id, false);
                });
        },
        setTimeDateIntervals() {
            this.time_intervals = [];
            var start_time = "09:00";
            var end_time = "17:00";

            if(this.sessions) {
                Object.keys(this.sessions).forEach(session => {

                    this.sessions[session].forEach(appointment => {
                        if(this.moment(appointment.from).format("HH:mm") < start_time) {
                            start_time = this.moment(appointment.from).format("HH:mm");
                        }
                        if(this.moment(appointment.to).format("HH:mm") > end_time) {
                            end_time = this.moment(appointment.to).format("HH:mm");
                        }
                    });
                });
            }
            var now = this.moment(start_time, "HH:mm");
            var end = this.moment(end_time, "HH:mm");

            while(now.isBefore(end)) {
                this.time_intervals.push(this.moment(now));
                now.add(15, "minutes")
            }

            var now_date = this.moment();
            var end_date = this.moment(now_date).add(30, "days");
            this.days = [];
            while(now_date.isBefore(end_date)) {
                this.days.push(this.moment(now_date));
                now_date.add(1, "day")
            }
        },
        getMinuteDifference(start, end) {
            var sameDayEnd = start.clone().set({hour: end.format('HH'), minute: end.format('mm')});
            return sameDayEnd.diff(start, "minutes");

        },
        getOffset(appointment) {
            return (this.dayHeadingHeight + (this.m15Height * (this.getMinuteDifference(this.time_intervals[0], this.moment(appointment.start_at)) / 15))) + "em";
        },
        getHeight(appointment) {
            return (this.m15Height * (this.getMinuteDifference(this.moment(appointment.start_at), this.moment(appointment.end_at)) / 15)) + "em";
        },
        getAppointmentSessions(user_id, site_id, show_loading) {
            if(typeof show_loading == "undefined") {
                show_loading = true;
            }
            if(show_loading) {
                this.setLoading(true);
            }
            axios.get(this.$root.apiBase
                    + '/appointments/user/' + user_id + "/" + site_id).then((res) => {

                this.sessions = res.data["appointment_sessions"];
                this.setTimeDateIntervals();
                this.getPendingInvitations(user_id, site_id);
                this.setLoading(false);
                //console.log(this.getMinuteDifference(this.time_intervals[0], this.moment(this.sessions[this.days[1].format("YYYY-MM-DD")][1].start_at)));
                //console.log(5 * (this.time_intervals[1].diff(this.moment(this.days[0].format('YYYY-MM-DD') + " " + this.moment(this.sessions[this.days[0].format("YYYY-MM-DD")][1].start_at).format('HH:mm')), "minutes") / 15) + "em");
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "load");
                this.$router.push({path: "/profile"});
            });
        },
        getPendingInvitations(user_id, site_id) {

            axios.get(this.$root.apiBase
                    + '/appointments/getPendingInvitations/' + user_id + "/" + site_id).then((res) => {

                this.pending_invitations = res.data.data;
                this.setLoading(false);
                //console.log(this.getMinuteDifference(this.time_intervals[0], this.moment(this.sessions[this.days[1].format("YYYY-MM-DD")][1].start_at)));
                //console.log(5 * (this.time_intervals[1].diff(this.moment(this.days[0].format('YYYY-MM-DD') + " " + this.moment(this.sessions[this.days[0].format("YYYY-MM-DD")][1].start_at).format('HH:mm')), "minutes") / 15) + "em");
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "load");
                this.$router.push({path: "/profile"});
            });
        },

        editAppointment(appointment) {
            this.selected_appointment = appointment.appointment;
            Vue.nextTick(() => {
                this.$refs.editAppointment.show();
            });
        },
        createAppointment(appointment) {
            this.selected_appointment = appointment;
            this.selected_session = this.sessions[this.moment(appointment.from).format('YYYY-MM-DD')];
            Vue.nextTick(() => {
                this.$refs.editAppointment.show();
            });
        }
    }
}

</script>
